import { updateProjectDetail, getProjectById, handleUpdateProjectResource } from '@/service/projectService';
import { uploadFileToS3, uploadFileToS3WithContentType } from '@/service/s3Service';
import Utils from '@/common/utils/utils';
import { I18n, Storage } from 'aws-amplify';
import Constant from '@/common/constant/Constant';
import { isEqual } from 'lodash';
import { getRichTextFieldContent } from '@/component/ticketList/handler/TicketHandler';
import { getPublicAPI } from '@/service/publicService';
import { getTicketById } from '@/service/ticketService';
import localStorageUtil from '@/common/utils/localStorageUtil';
import { LANGUAGE_CODES } from '@/common/constant/LanguageCodes';
import Logger from '@/common/utils/Logger';
import { uploadCssFileToS3 } from './PublicKnowledgeSiteSettingHandler';
export const validateKLRoboMessageConfig = value => {
    if (!value || Utils.isEmptyString(value.trim())) return '';
    // Validate JSON format
    // Returns error code if:
    // - Empty input
    // - Invalid JSON format  
    // - Missing `default_language`, or invalid language code
    // - Missing `messages` object
    // - Invalid language codes (not 2-letter code or not in LANGUAGE_CODES)
    // Frontend will display error, backend will fallback to default
    try {
        const parsedValue = JSON.parse(value);

        const { default_language, messages } = parsedValue;

        // 1. Validate default_language
        if (!default_language || !LANGUAGE_CODES.hasOwnProperty(default_language)) {
            return 'MSG_INVALID_JSON_VALUE'; // missing default_language return error
        }

        // 2. Validate messages object
        if (!messages || typeof messages !== 'object') {
            return 'MSG_INVALID_JSON_VALUE'; // missing messages object return error
        }
        
        const isValidLang = Object.keys(messages).every(lang =>
            LANGUAGE_CODES.hasOwnProperty(lang)
        );
        if (!isValidLang) {
            return 'MSG_INVALID_JSON_VALUE';
        }

        return '';
    } catch (error) {
        return 'MSG_INVALID_JSON_VALUE'; // invalid format return error
    }
};


export const validateNumberOptionDisplayLength = value => {
    if (value > Constant.SETTING_CHAT_BOT.MAX_OPTION_DISPLAY_LENGTH.MAX) {
        return I18n.get('MSG-CM-OVER-MAXLENGTH').replace(
            '{{maxLength}}',
            `${Constant.SETTING_CHAT_BOT.MAX_OPTION_DISPLAY_LENGTH.MAX}`
        );
    };
    return '';
};

export const validateNumberHitKnowledgeTicket = value => {
    if (!value) return 'COMMSG014'
    if (value < Constant.SETTING_CHAT_BOT.NUMBER_HIT_KNOWLEDGE_TICKET.MIN || value > Constant.SETTING_CHAT_BOT.NUMBER_HIT_KNOWLEDGE_TICKET.MAX) return 'PLKNOWMSG006';
    return '';
};

export const validateMaxLengthAnswers = value => {
    if (!value && value !== 0) return 'COMMSG014'
    if (value < Constant.SETTING_CHAT_BOT.MAX_LENGTH_ANSWER.MIN || value > Constant.SETTING_CHAT_BOT.MAX_LENGTH_ANSWER.MAX) return 'PLKNOWMSG006';
    return '';
};

export const validateChatbotTextInHeader = value => {
    if (!value || Utils.isEmptyString(value.trim())) return 'COMMSG014';

    if (value.length > 256) return 'COMMSG037';
    return '';
};

export const validateChatbotName = value => {
    if (!value || Utils.isEmptyString(value.trim())) return 'COMMSG014'
    if (value.length > 256) return 'COMMSG037';
    return '';
};

export const getError = (errors, fieldName) => {
    if (Utils.isEmptyObject(errors)) return null;
    return errors[fieldName];
};

export const getValue = (data, fieldName) => {
    if (Utils.isEmptyObject(data)) return null;
    return data[fieldName];
};

export const onCopyURL = (organizationDomain, projectAlias) => {
    let url = `${process.env.REACT_APP_DOMAIN_NAME}${organizationDomain}/${projectAlias}/kb`;
    navigator.clipboard.writeText(url);
}

const isDataChanged = async (API, projectDetail) => {
    if (Utils.isEmptyObject(projectDetail)) return true;

    let lastedProjectData = await getProjectById(API, projectDetail.id);

    if (Utils.isEmptyObject(lastedProjectData)) return true;

    let lastedChatbotSetting = Utils.convertJSONDataToObject(lastedProjectData.chatbotSetting);
    let currentChatbotSetting = Utils.convertJSONDataToObject(projectDetail.chatbotSetting);

    if (isEqual(lastedChatbotSetting, currentChatbotSetting)) return false;
    return true;
}

const displayErrorOnSubmit = async (settingData, valueFreeMsg, errors, setErrors, basicPromptTicket = {}, setErrorBasicPrompt) => {
    let errorsClone = { ...errors };
    if (!settingData.chatbotTextInHeader) {
        errorsClone.chatbotTextInHeader = 'COMMSG014'
    }
    
    let contentText = getRichTextFieldContent(valueFreeMsg);

    if (Utils.isEmptyString(contentText) && settingData.actionWhenNotResolve === Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.DISPLAY_FREE_MESSAGE) {
        errorsClone.freeMsg = 'COMMSG014'
    } else {
        delete errorsClone.freeMsg
    }
    if (!settingData.chatbotName) {
        errorsClone.chatbotName = 'COMMSG014'
    }
    if (!settingData.maxNumberAnswer) {
        errorsClone.maxNumberAnswer = 'COMMSG014'
    }
    if (!settingData.numberHitKnowledgeTicket) {
        errorsClone.numberHitKnowledgeTicket = 'COMMSG014'
    }
    if (parseInt(settingData.optionDisplayLength) > Constant.SETTING_CHAT_BOT.MAX_OPTION_DISPLAY_LENGTH.MAX) {
        errorsClone.optionDisplayLength = validateNumberOptionDisplayLength(settingData.optionDisplayLength);
    }
    if (!settingData.styleSheet) {
        errorsClone.styleSheet = 'COMMSG014';
    }

    //check basic prompt
    if (!Utils.isEmptyObject(basicPromptTicket)) {
        switch (basicPromptTicket?.promptFlag) {
            case Constant.ACTIVE_FLAG.INACTIVE: {
                setErrorBasicPrompt(Constant.AI_PROMPT_VALID_CODE.MSG_CM_INVALID_LINK);
                return true;
            }
            case Constant.ACTIVE_FLAG.ACTIVE: {
                const isValidBasicPrompt = await checkBasicPromptValid(basicPromptTicket.id);
                if (!isValidBasicPrompt) {
                    setErrorBasicPrompt(Constant.AI_PROMPT_VALID_CODE.MSG_CM_INVALID_LINK);
                    return true;
                }
                break
            }
            default:
        }
    }

    if (Utils.isEmptyObject(errorsClone)) {
        setErrors(errorsClone);
        return false
    } else {
        setErrors(errorsClone);
        return true
    }
}

export const onSubmitSetting = async (
    corporationDetail,
    projectDetail,
    settingData,
    valueFreeMsg,
    croppedHeaderIcon,
    croppedImage,
    croppedSendIcon,
    setCroppedImage,
    setCroppedHeaderIcon,
    setCroppedSendIcon,
    errors,
    setErrors,
    enqueueSnackbar,
    setIsLoading,
    setReloadPage,
    isEdited,
    setIsShowDialogReload,
    dataHtmlScript,
    categoryList,
    chatBotCategorySetting,
    setChatbotCategorySetting,
    titleCategory,
    userId,
    chatBotCategoryList,
    setChatbotCategoryList,
    setIsDisableBtnSubmit,
    setIsEdited,
    API,
    basicPromptTicket,
    setErrorBasicPrompt,
    setIsShowUploadError
) => {
    try {
        setIsLoading(true);
        const isChange = await isDataChanged(API, projectDetail);
        if (isChange) {
            setIsLoading(false);
            setIsShowDialogReload(true);
            return;
        }
        const isInValidValues = await displayErrorOnSubmit(settingData, valueFreeMsg, errors, setErrors, basicPromptTicket, setErrorBasicPrompt)

        if (isInValidValues) {
            setIsLoading(false);
            setIsDisableBtnSubmit(true);
            return;
        }

        let removedCategoryName = categoryList.map(category => {
            return { id: category.id, order: category.order };
        });
        const newVersion =
            settingData?.versionKnowledgeRoboStyleCss &&
            typeof Number(settingData?.versionKnowledgeRoboStyleCss) == 'number'
                ? Number(settingData?.versionKnowledgeRoboStyleCss) + 1
                : 1;
        let cssVersion = Number(settingData?.versionKnowledgeRoboStyleCss) || 1;
        let hasUploadError = false;

        //styleSheet
        const newFileKey = Utils.genKeyFileCss(corporationDetail.id, projectDetail.id, newVersion, Constant.KEY_FILE_CSS_TYPE.KNOWLEDGE_ROBO);
        const currentFileKey = Utils.genKeyFileCss(corporationDetail.id, projectDetail.id, settingData.versionKnowledgeRoboStyleCss, Constant.KEY_FILE_CSS_TYPE.KNOWLEDGE_ROBO);
        try {
            await uploadCssFileToS3(newFileKey, settingData.styleSheet);
            cssVersion = newVersion;
            await Storage.remove(currentFileKey).catch(err => {
                Logger.error('Error deleting old CSS file:', err);
            });
        } catch (cssUploadError) {
            Logger.error('SettingChatbotHandler - upload CSS failed, keep current version: ', cssUploadError);
            hasUploadError = true;
        }

        let updateSettingData = {
            projectId: projectDetail.id,
            isActivateChatbot: settingData.isActivateChatbot,
            usingAI: settingData.usingAI,
            basicPrompt: settingData.basicPrompt,
            useImageInAnswer: settingData.useImageInAnswer,
            actionWhenNotResolve: settingData.actionWhenNotResolve,
            freeMsg: valueFreeMsg,
            htmlScript: dataHtmlScript,
            chatbotName: settingData.chatbotName,
            maxNumberAnswer: settingData.maxNumberAnswer,
            headersColor: settingData.headersColor,
            headerIcon: settingData?.headerIcon,
            logo: settingData.logo,
            sendIcon: settingData?.sendIcon,
            chatbotTextInHeader: settingData.chatbotTextInHeader,
            numberHitKnowledgeTicket: settingData.numberHitKnowledgeTicket,
            categoryList: removedCategoryName,
            optionDisplayLength: settingData?.optionDisplayLength || 0,
            versionKnowledgeRoboStyleCss: cssVersion,
            enableListTicket: settingData.enableListTicket,
            messageConfig: Utils.genKLRoboMsgConfigS3path(corporationDetail.id, projectDetail.id), // when save in DB, value = s3Path
        };

        //upload image
        if(
            !Utils.isEmptyObject(corporationDetail) &&
            !Utils.isEmptyObject(projectDetail) 
        ) {
            let fileExtension = ""
            let processUploadS3 = []
            let newLogoPath = null;
            let newHeaderIconPath = null;
            let newSendIconPath = null;

            if (!Utils.isEmptyObject(croppedImage)) {
                fileExtension = croppedImage?.name?.split('.').pop() || '';
                newLogoPath = `${corporationDetail?.organizationDomain}/${
                    projectDetail.id
                }/chat_bot/logo/${Date.now().toString()}.${fileExtension}`;
            }

            if (!Utils.isEmptyObject(croppedHeaderIcon)) {
                fileExtension = croppedHeaderIcon?.name?.split('.').pop() || '';
                newHeaderIconPath = `${corporationDetail?.organizationDomain}/${
                    projectDetail.id
                }/chat_bot/header_icon/${Date.now().toString()}.${fileExtension}`;
            }

            if (!Utils.isEmptyObject(croppedSendIcon)) {
                fileExtension = croppedSendIcon?.name?.split('.').pop() || '';
                newSendIconPath = `${corporationDetail?.organizationDomain}/${
                    projectDetail.id
                }/chat_bot/send_icon/${Date.now().toString()}.${fileExtension}`;
            }

            // Always upload messageConfig to S3, even if empty
            // Empty string is valid (will use defaults in ChatBot, but keep empty in UI)
            const uploadMsgConfigProcess = uploadFileToS3WithContentType(
                Utils.genKLRoboMsgConfigS3path(corporationDetail.id, projectDetail.id),
                settingData.messageConfig || '',
                'application/json'
            );
            processUploadS3.push(uploadMsgConfigProcess);

            if (processUploadS3.length > 0) await Promise.all(processUploadS3);

            let processUploadImages = [];
            let imageKeys = [];
            if (newLogoPath) {
                processUploadImages.push(uploadLogoS3(croppedImage, newLogoPath));
                imageKeys.push({ key: 'logo', path: newLogoPath });
            }
            if (newHeaderIconPath) {
                processUploadImages.push(uploadLogoS3(croppedHeaderIcon, newHeaderIconPath));
                imageKeys.push({ key: 'headerIcon', path: newHeaderIconPath });
            }
            if (newSendIconPath) {
                processUploadImages.push(uploadLogoS3(croppedSendIcon, newSendIconPath));
                imageKeys.push({ key: 'sendIcon', path: newSendIconPath });
            }

            if (processUploadImages.length > 0) {
                const results = await Promise.allSettled(processUploadImages);
                results.forEach((result, index) => {
                    if (result.status === 'fulfilled') {
                        updateSettingData[imageKeys[index].key] = imageKeys[index].path;
                    } else {
                        Logger.error(`SettingChatbotHandler - upload ${imageKeys[index].key} failed, keep current: `, result.reason);
                        hasUploadError = true;
                    }
                });
            }
            setCroppedImage(null);
            setCroppedHeaderIcon(null);
            setCroppedSendIcon(null);
        }

        // create chat bot category setting
        let listCategoryToAdd = [];
        chatBotCategoryList.forEach(category => {
            let newCategoryParams = {
                usage: Constant.USAGE_TYPE.PROJECT,
                affiliationOrganization: projectDetail.affiliationOrganization,
                active: Constant.ACTIVE_FLAG.ACTIVE,
                type: Constant.PROJECT_TYPE.PROJECT_CHATBOT_CATEGORIES,
                name: { jp: { A: 'F', text: category.titleCategory } },
                chatBotCategorySetting: category,
                projectId: projectDetail.id,
                id2: projectDetail.id,
                isDesk: false,
                isPublic: false,
                isGuest: false
            };
            listCategoryToAdd.push(newCategoryParams)
        })
        const updateChatbotCategory = {
            chatbotSetting: JSON.stringify(updateSettingData),
            listCategoryToAdd: JSON.stringify(listCategoryToAdd),
            method: Constant.UPDATE_PROJECT_RESOURCE_METHOD.SETTING_CHATBOT,
            corporationId: projectDetail.affiliationOrganization,
            userId
        }
        const updatedProject = await handleUpdateProjectResource(API, updateChatbotCategory);
        if(!updatedProject.status){
            let responseDataUpdate = Utils.convertJSONDataToObject(updatedProject.data);
            if(responseDataUpdate.error === 'COMMSG030'){
                setIsShowDialogReload(true);
                return
            }
        }
        if(!updatedProject) {
            enqueueSnackbar(I18n.get('SYSMSG001'), {
                variant: 'error',
                autoHideDuration: 3000,
            });
        }

        setChatbotCategorySetting({});
        setChatbotCategoryList([]);
        setIsLoading(false);
        setIsEdited(false);
        setIsDisableBtnSubmit(true);

        if (hasUploadError) {
            setIsShowUploadError(true);
        } else {
            enqueueSnackbar(I18n.get('COMMSG045'), {
                variant: 'success',
                autoHideDuration: 3000,
            });
            setReloadPage(Date.now().toString());
        }

    } catch (error) {
        setIsLoading(false);
        setChatbotCategorySetting({});
        setChatbotCategoryList([]);
        enqueueSnackbar(I18n.get('SYSMSG001'), {
            variant: 'error',
            autoHideDuration: 3000,
        });
        setIsEdited(false);
        setIsDisableBtnSubmit(true);
        setReloadPage(Date.now().toString());
    }
};

const uploadLogoS3 = async (croppedImage, filePath) => {
    if (croppedImage && croppedImage.file) {
        let fileUpload = { ...croppedImage };
        fileUpload.key = filePath;
        let uploadAvatar = await uploadFileToS3(filePath, fileUpload, {
            level: 'public',
            acl: "public-read",
        });
        if (!uploadAvatar) {
            throw new Error('Logo file upload failed');
        }

        // Verify file is uploaded successfully
        let getFileResult = await Storage.get(filePath, {
            download: true,
            cacheControl: 'no-cache'
        });

        if (!getFileResult) {
            throw new Error('Logo file upload verification failed');
        }
    }
};

const generateIframe = argsCommon => {
    let iframeSrcData = {
        subDomain: argsCommon.subDomain,
        projectId: argsCommon.projectDetail?.projectId
    };
    let encodeData = Utils.encodeDataByCrypto(
        iframeSrcData,
        Constant.SECRET_KEY_ENCRYPT_GENERATE_DATA
    );
    let iframeSrc = `${window.location.origin}${Constant.IFRAME_LOGIN_ROUTER}&info=${encodeData}`;
    let iframeProperty = `src="${iframeSrc}"`;
    if (argsCommon.headersColor) {
        iframeProperty = `${iframeProperty} headersColor="${argsCommon.headersColor}"`
    }
    if (argsCommon.valueFreeMsg) {
        iframeProperty = `${iframeProperty} freeMsg="${argsCommon.valueFreeMsg}"`;
    }
    return `<iframe ${iframeProperty}></iframe>`;

}

export const saveInActiveUrl = async (
    API,
    projectDetail,
    settingData,
    setIsLoading,
    setReloadPage,
    enqueueSnackbar,
) => {
    try {
        let currentSettingData = Utils.convertJSONDataToObject(
            projectDetail.chatbotSetting
        );
        if (!Utils.isEmptyObject(currentSettingData)) {
            setIsLoading(true);
            let updateSettingData = { ...currentSettingData };
            updateSettingData.isActivateChatbot = false;

            let updateProjectData = {
                chatbotSetting: JSON.stringify(updateSettingData),
            };

            let updateResult = await updateProjectDetail(API, projectDetail.id, updateProjectData);
            if (!updateResult) {
                throw new Error('updateProjectDetail :>> FALSE');
            }
            setIsLoading(false);
        }

        setReloadPage(Date.now().toString());
        enqueueSnackbar(I18n.get('COMMSG045'), {
            variant: 'success',
            autoHideDuration: 3000
        });
    } catch (error) {
        console.log('chatbotSettingHandler :>> saveInActivateChatbot ~ error :>> ', error);
    }
};

export const getCategoryListOfProject = async (API, projectId) => {

    let requestParams = {
        projectId: projectId,
        getApiType: Constant.GET_API_PUBLIC_TYPE.GET_CHAT_BOT_CATEGORY_LIST
    };

    const response = await getPublicAPI(API, requestParams);
    let payload = Utils.convertJSONDataToObject(response.payload);

    return payload;
};


export const getBooleanValueOptionDisplayLength = (chatbotSetting) => {
    if (!chatbotSetting || chatbotSetting.optionDisplayLength === 0) return false;
    return true;
}

export const handleOnBlurBasicPromptSetting = async (
    e,
    setSettingData,
    setBasicPromptDetail,
    setBasicPromptSetting,
    setErrorBasicPrompt,
    setIsLoading,
    setIsDisableBtnSubmit,
    setIsEdited
) => {
    const linkValue = e.target.value;
    if (Utils.isEmptyString(linkValue)) {
        setErrorBasicPrompt('');
        setIsDisableBtnSubmit(false)
        setIsEdited(true)
        return;
    }

    if (!Utils.isValidLinkPromptInput(linkValue)) {
        setErrorBasicPrompt(Constant.AI_PROMPT_VALID_CODE.MSG_CM_INVALID_LINK);
        setIsLoading(false);
        setIsDisableBtnSubmit(true)
        setIsEdited(false)
        return;
    }
    setIsLoading(true);

    let ticketId = await Utils.getTicketIdByShareLink(linkValue);
    const isValidBasicPrompt = await checkBasicPromptValid(ticketId)
   
    if (!isValidBasicPrompt) {
        const errorMgs = Constant.AI_PROMPT_VALID_CODE.MSG_CM_INVALID_LINK
        setErrorBasicPrompt(errorMgs);
        setIsDisableBtnSubmit(true)
        setIsEdited(false)
    }else{
        const basicTicket = await getTicketById(null, ticketId);
        setSettingData(pre => {
            return { ...pre, basicPrompt: linkValue };
        });
        setBasicPromptDetail(basicTicket);
        setBasicPromptSetting(linkValue);
        setIsDisableBtnSubmit(false)
        setIsEdited(true)
        setErrorBasicPrompt("")
    }
    return setIsLoading(false);
};

const checkBasicPromptValid = async ticketId => {
    const corporationId = localStorageUtil.getAffiliationOrganization()
    const userId = localStorageUtil.getUserDetailId()
    
    const updateChatbotCategory = {
        chatbotSetting: JSON.stringify({}),
        listCategoryToAdd: JSON.stringify([]),
        method: Constant.UPDATE_PROJECT_RESOURCE_METHOD.BASIC_PROMPT_VALIDATE,
        corporationId,
        userId,
        ticketId
    };

    const validBasicPrompt = await handleUpdateProjectResource(null, updateChatbotCategory);
    return validBasicPrompt.status;
};

export const handleClickRemoveBasicPromptSetting = async (
    setSettingData,
    setBasicPromptDetail,
    setBasicPromptSetting,
    setIsDisableBtnSubmit,
    setErrorBasicPrompt
) => {
    setSettingData(prev => {
        return { ...prev, basicPrompt: '' };
    });
    setBasicPromptDetail({});
    setBasicPromptSetting('');
    setErrorBasicPrompt("")
    return setIsDisableBtnSubmit(false)
};